import oRequest from '@/libsV2/request.js';

const URL = {
    BANNER: 'ssp/adment/info', // 广告Banner
}

export const getBanner = (adment_id) => {
    return oRequest.getData(URL.BANNER, { adment_id: adment_id || '' });
};